/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconCalendar19 extends React.Component {
  render() {
    const iconClasses = classNames("icon calendar19", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M 6 4 C 4.895 4 4 4.895 4 6 L 4 24 C 4 25.105 4.895 26 6 26 L 24 26 C 25.105 26 26 25.105 26 24 L 26 6 C 26 4.895 25.105 4 24 4 L 6 4 z M 6 6 L 24 6 L 24 10 L 6 10 L 6 6 z M 18.076172 14.308594 C 19.072172 14.308594 19.88925 14.713172 20.40625 15.451172 C 20.88025 16.086172 21.128906 16.959141 21.128906 17.994141 C 21.129906 20.302141 19.963359 21.728516 18.068359 21.728516 C 16.652359 21.728516 15.533656 20.904891 15.347656 19.712891 L 17.101562 19.712891 C 17.213562 20.103891 17.599125 20.351562 18.078125 20.351562 C 18.947125 20.351562 19.499547 19.454391 19.435547 18.150391 L 19.386719 18.150391 L 19.341797 18.150391 C 19.024797 18.804391 18.394125 19.171875 17.578125 19.171875 C 16.245125 19.171875 15.259766 18.185656 15.259766 16.847656 C 15.259766 15.363656 16.426172 14.308594 18.076172 14.308594 z M 10.65625 14.496094 L 12.449219 14.496094 L 12.449219 21.542969 L 10.65625 21.542969 L 10.65625 16.113281 L 10.564453 16.113281 L 8.8652344 17.259766 L 8.8652344 15.716797 L 10.65625 14.496094 z M 18.09375 15.689453 C 17.46875 15.689453 16.980469 16.171969 16.980469 16.792969 C 16.980469 17.417969 17.45975 17.886719 18.09375 17.886719 C 18.72375 17.886719 19.201172 17.418828 19.201172 16.798828 C 19.201172 16.172828 18.71875 15.689453 18.09375 15.689453 z" />
      </svg>
    );
  }
}

IconCalendar19.defaultProps = {
  className: null
};

IconCalendar19.propTypes = {
  className: PropTypes.string
};

export default IconCalendar19;
